import { Badge } from 'rsuite';
import { FaPen, FaPizzaSlice, FaSave } from 'react-icons/fa';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { CustomInput } from '../CustomInput';
import { CustomInputNumber } from '../CustomInputNumber';
import { CustomButton } from '../CustomButton';
import { useTamanho } from './useTamanho';
import * as S from './styles';

export const TamanhoPizza = (props) => {
  const { theme } = useCustomTheme();
  const { colors } = theme;

  const {
    selected,
    editTamanho,
    tamanhoRef,
    isDragging,
    handlerId,
    handleEditTamanho,
    setEditTamanho,
    handleSaveEdit,
    handleSelectSize,
    handleActiveInactive,
  } = useTamanho(props);

  return (
    <S.Row
      key={props.item.Id}
      id={props.item.Descricao}
      ref={props.isManaging ? tamanhoRef : null}
      isDragging={isDragging}
      isManaging={props.isManaging}
      isSelected={selected}
      data-handler-id={handlerId}
    >
      <S.Col xs={!props.isManaging ? 8 : 12}  isSelected={selected}>
        {editTamanho?.Id === props.item.Id ? (
          <CustomInput
            value={editTamanho?.Descricao}
            onChange={(newValue) =>
              setEditTamanho((prev) => ({
                ...prev,
                Descricao: newValue,
              }))
            }
          />
        ) : (
          props.item.Descricao
        )}
      </S.Col>
      {!props.isManaging && (
        <S.Col
          xs={1}
          isSelected={selected}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          {props.item.TipoPizza && (
            <FaPizzaSlice
              color={selected ? colors.white : colors.primary}
              title="Tamanho de pizza"
            />
          )}
        </S.Col>
      )}
      {!props.isManaging && (
        <S.Col xs={4}>
          <CustomButton
            style={{ paddingTop: 2, paddingBottom: 2, width: '80%' }}
            appearance={selected ? 'ghost' : 'primary'}
            color={selected ? colors.white : colors.primary}
            onClick={handleSelectSize}
          >
            {selected ? 'Usando' : 'Usar'}
          </CustomButton>
        </S.Col>
      )}
      <S.Col xs={4} isSelected={selected}>
        {editTamanho?.Id === props.item.Id ? (
          <CustomInputNumber
            value={editTamanho?.QtdSabores}
            onChange={(newValue) =>
              setEditTamanho((prev) => ({
                ...prev,
                QtdSabores: newValue,
              }))
            }
          />
        ) : (
          `${props.item.QtdSabores} ${
            props.item.QtdSabores > 1 ? ' Sabores' : ' Sabor'
          }`
        )}
      </S.Col>
      <S.Col xs={4} isSelected={selected}>
        {editTamanho?.Id === props.item.Id ? (
          <CustomInputNumber
            value={editTamanho?.QtdPedacos}
            onChange={(newValue) =>
              setEditTamanho((prev) => ({
                ...prev,
                QtdPedacos: newValue,
              }))
            }
          />
        ) : (
          `${props.item.QtdPedacos} ${
            props.item.QtdPedacos > 1 ? ' Pedaços' : ' Pedaço'
          }`
        )}
      </S.Col>
      <S.Col xs={3} isSelected={selected}>
        <Badge
          color={props.item.Ativo ? 'green' : 'red'}
          content={props.item.Ativo ? 'Ativo' : 'Inativo'}
          onClick={() => handleActiveInactive(props.item)}
          style={{ cursor: 'pointer', width: '80%', textAlign: 'center' }}
        />
      </S.Col>
      {props.isManaging && (
        <S.Col xs={1} isSelected={selected}>
          <S.EditTamanho
            onClick={() =>
              editTamanho?.Id === props.item.Id
                ? handleSaveEdit(props.item)
                : handleEditTamanho(props.item)
            }
          >
            {editTamanho?.Id === props.item.Id ? (
              <FaSave color={theme.colors.success} />
            ) : (
              <FaPen color={theme.colors.text} />
            )}
          </S.EditTamanho>
        </S.Col>
      )}
    </S.Row>
  );
};
